<template>
  <div v-for="(item, index) in $props.options" :key="index" style="margin: 10px;display: flex;" v-if="type == 'radio'">
    <input type="radio" :name="item.code" :id="item.code" :checked="item.code == innerValue" @click="select($event, item)"/><span style="margin: 0 5px;">{{item.label}}</span>
  </div>
  <div v-else>
    <div>
      <button :class="[{
        'sweet-button--active': innerValue == item.code
      }]" @click="select($event, item)" 
      v-for="(item, index) in $props.options"
      class="sweet-button sweet-button--default">{{item.label}}</button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'

  const props = withDefaults(
    defineProps<{
      modelValue: Boolean,
      disabled?: Boolean,
      options: Array,
      optionKey?: Object,
      type: String
    }>(),
    {
      modelValue: false,
      disabled: false,
      options: [],
      optionKey: {},
      type: 'radio'
    }
  )

  const emits = defineEmits<{
    (e: 'update:modelValue', value: boolean): void,
    (e: 'change', value: boolean): void
  }>()

  const innerValue = ref(props.modelValue)

  // 侦听文本变化并传给外界
  watch(
    () => innerValue.value,
    () => {
        emits('update:modelValue', innerValue.value)
        // emits('change', innerValue.value)
    }
  )
  // 侦听默认值 外界第一次传进来一个 v-model 就赋值给 contentValue
  watch(
    () => props.modelValue,
    (n: any) => {
      innerValue.value = n
    }
  )

  const select = (e, item) => {
      e.preventDefault();      
      innerValue.value = item.code
  }
</script>

<style lang="scss" scoped>
.sweet-button {
  padding: 8px 15px;
  border: none;
  color: white;
  font-size: 14px;
  outline: none;
  transition: .1s;
  // margin-left: 10px;
  margin-top: 3px;
  line-height: 14px;
  min-width: 75px;
  cursor: pointer;
}

.sweet-button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.sweet-button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.sweet-button:not(:last-child) {
  border-right: 0;
}

.sweet-button--default {
  color: #606266;
  background-color: white;
  border: 1px solid #d9d9d9;
}

.sweet-button--active {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}
</style>
